import React from "react";
import { Link } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { TopBar } from "@/components/TopBar";
import { LabelCetak, LabelTermal } from "@/components/LabelTermal";
import { apiLabelContoh, formatApiErrorDetail } from "@/lib/api";
import { cssCetak } from "@/lib/label";

// Owner 2026-10-19 (requirement 71, v2.11): try the label printer at the shop with a label of fictional data.
const LANGKAH = [
  "Pasang driver Windows Blueprint BP-TD110BT, sambungkan USB, nyalakan printer.",
  "Windows → Printer → BP-TD110BT → Preferensi: ukuran kertas 100 × 150 mm, orientasi Potret. Jalankan kalibrasi gap/label dari tombol printer atau utilitas driver.",
  "Jadikan BP-TD110BT printer bawaan Windows (Default), supaya dialog cetak Chrome langsung memilihnya.",
  "Di halaman ini tekan 'Cetak contoh'. Di dialog Chrome: Tujuan = BP-TD110BT, Kertas 100 × 150 mm, Margin = Tidak ada, Skala 100%, centang 'Grafik latar' bila garis tidak muncul. Chrome mengingat pilihan ini.",
  "Periksa hasil: garis tepi tidak terpotong, huruf tajam (203 dpi), QR terbaca kamera HP dan membuka halaman SPK (wajib login).",
  "Cetak 20 label berturut-turut (tekan Cetak contoh 20×): tidak bergeser, tidak dobel.",
  "Uji kertas habis: cabut gulungan, cetak 1 label → printer memberi tanda; pasang lagi lalu 'Cetak ulang' dari tab Sudah dicetak.",
  "Nyalakan ulang PC, buka Chrome → Antrean Label → cetak 1 label: printer bawaan dan ukuran kertas masih benar.",
];

export default function UjiLabel() {
  const [isi, setIsi] = React.useState(null);
  const [error, setError] = React.useState(null);
  React.useEffect(() => { apiLabelContoh().then(setIsi).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message)); }, []);
  return (
    <div data-testid="uji-label" className="min-h-screen bg-slate-950 text-slate-200">
      <style>{cssCetak()}</style>
      <TopBar />
      <main className="mx-auto grid max-w-5xl gap-6 px-4 py-6 sm:px-6 lg:grid-cols-[1fr_auto] lg:px-8">
        <div className="space-y-4">
          <p className="text-xs uppercase tracking-wider text-slate-500"><Link to="/label" className="hover:text-amber-300">Antrean Label</Link> · Uji printer</p>
          <h1 className="text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl">Uji printer label</h1>
          {error && <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-2.5 text-sm text-red-300">{error}</div>}
          <ol className="list-decimal space-y-2 pl-5 text-sm text-slate-300">{LANGKAH.map((l) => <li key={l}>{l}</li>)}</ol>
          <button data-testid="uji-label-cetak" disabled={!isi} onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-50"><Printer size={16} /> Cetak contoh</button>
          <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4 text-sm text-slate-400">
            <h2 className="mb-1 font-semibold text-slate-200">Opsi nanti: cetak tanpa klik (kiosk-printing)</h2>
            <p>Chrome bisa dibuka dengan shortcut khusus (<code>--kiosk-printing</code>, profil Chrome tersendiri) sehingga dialog cetak tidak muncul dan label langsung keluar ke printer bawaan. Belum dipakai, karena risikonya: label tercetak di printer lain bila printer bawaan berubah, cetak dobel bila dua tab terbuka, dan kertas habis tidak terdeteksi (label tercatat "sudah dicetak" padahal tidak keluar). Pertimbangkan setelah cara satu klik dipakai 1 minggu.</p>
          </div>
        </div>
        <div className="mx-auto">
          <div className="mb-2 text-center text-xs text-slate-500">Pratinjau ukuran asli (100 × 150 mm)</div>
          <div className="border-2 border-dashed border-slate-500">
            {isi ? <LabelTermal isi={isi} contoh /> : <div className="p-10 text-slate-400"><Loader2 className="inline animate-spin" /></div>}
          </div>
        </div>
      </main>
      {isi && <LabelCetak isi={{ ...isi, grup_label: `${isi.grup_label} · CONTOH` }} />}
    </div>
  );
}
